import { array, InferType, object, string } from "yup";
import i18n from "utilities/i18n";
import { isValidCIDR } from "./CidrValidation";

let cidrSchema = string()
  .label("SUBNET_RANGE")
  .test(
    "cidr",
    i18n.t("CIDR_ERROR"),
    (value: string) => isValidCIDR(value) || value === undefined
  )
  .required();

let privateSubnetSchema = object({
  ruleId: string(),
  cidr: cidrSchema
});

let publicSubnetSchema = object({
  ruleId: string(),
  cidr: cidrSchema,
  privateSubnets: array().of(privateSubnetSchema)
});

export const SubnetMapSchema = object({
  siteId: string().required(),
  publicSubnets: array().of(publicSubnetSchema)
});

let subnetRuleSchema = object({
  ruleId: string().required(),
  publicCidr: string().required(),
  privateCidr: string()
    .required()
    .nullable(),
  siteId: string().required()
});

export type SubnetMap = InferType<typeof SubnetMapSchema>;
export type SubnetRule = InferType<typeof subnetRuleSchema>;
export type PublicSubnet = InferType<typeof publicSubnetSchema>;
export type PrivateSubnet = InferType<typeof privateSubnetSchema>;
